import createReactClass from 'create-react-class';
// -*- mode: jsx;-*-
/* global readCookie isEmailAddress */

import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
import { submitEmailContactSignup } from './submitEmailContactSignup.js';


export const EmailContactSignUpWidget = createReactClass({
    mixins: [PureRenderMixin],

    getInitialState: function () {
        return {
            success: false,
            loading: false,
            message: null,
            email: null,
        };
    },

    handleCallback: function (response) {
        var data = response.data;
        this.setState({
            success: !!data.success,
            loading: false,
            message: data.message,
            email: this.state.email,
        });
    },

    submitEmailContactSignUp: function (email) {
        submitEmailContactSignup(null, null, email, this.handleCallback, function(xhr, status, err) {
            console.log(location.href, status, err.toString());
            // TODO this will NPE out every time. We may not need to fix this - this is an abandoned feature and we're
            //  working on its replacement - but if we do choose to replace it, the case is WS-34619 .
            this.handleCallback();
        }.bind(this));

        this.setState(
            {
                loading: true,
                email: email,
            },
        );
    },

    onEmailSubmit: function (event) {
        var email = this.state.email;
        if (!this.state.success && email && isEmailAddress(email)) {
            this.submitEmailContactSignUp(email);
        } else if (!this.state.success) {
            this.setState({ message: 'Your email address is missing or invalid.' });
        }
        event.preventDefault();
    },

    onChangeEmail: function (event) {
        var email = event.target.value;
        this.setState({ email: email });
    },

    render: function () {
        var state = this.state;

        return (
            <div className="input-holder js-email-contact-signup" aria-live="polite">
                <label htmlFor="emailSignUp">{state.message || 'Get local classroom projects in your inbox'}</label>
                <input type="email"
                    id="emailSignUp"
                    placeholder="Email address"
                    onChange={ this.onChangeEmail }/>
                <input type="submit" className="button-secondary small" value="Sign up"
                    onClick={this.onEmailSubmit} onSubmit={this.preventDefault}/>
            </div>
        );
    },
});
